import React from 'react';
import { Box, Typography, useTheme, SxProps, Theme } from '@mui/material';

interface LogoTextProps {
  color?: string;
  showSubtitle?: boolean;
}

const LogoText: React.FC<LogoTextProps> = ({ color, showSubtitle = false }) => {
  const theme = useTheme();
  const defaultColor = theme.palette.mode === 'light' ? theme.palette.primary.main : '#E1E8ED';

  const subtitleStyles: SxProps<Theme> = {
    color: color || defaultColor,
    fontFamily: "'Outfit', sans-serif",
    fontWeight: 500,
    letterSpacing: '0.02em',
    fontSize: '0.875rem',
    textTransform: 'none',
    marginTop: '4px',
    opacity: 0.9
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      {showSubtitle && (
        <Typography
          variant="subtitle2"
          component="div"
          sx={subtitleStyles}
        >
          Elevate your financial journey.
        </Typography>
      )}
    </Box>
  );
};

export default LogoText; 